<template>
  <illustration-layout :cclink="this.$store.state.cclink + 'INSPIRING_PROJECTS'">
    <div style="text-align:center;padding:35px;">
      <div style="color:#ce0e2d;font-weight:500;font-size:56px">
        Inspiring Projects
      </div>
      <div style="color:#6d6d64;font-size:38px">
        Our illustrators at work
      </div>
      <inspiring-panel v-for="artist in item.artists" :key="artist.portfolio_url" :artist="artist" />
    </div>
  </illustration-layout>
</template>

<script>
import InspiringPanel from '../components/InspiringPanel'
import NewTalentLoader from '../mixins/NewTalentLoader'
import IllustrationLayout from '../layouts/IllustrationLayout.vue'
export default {
  components: {
    InspiringPanel,
    IllustrationLayout
  },
  mixins: [NewTalentLoader]
  
}
</script>

<style>
b {
  font-size:23px;
}
</style>